var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarBody(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 115.348,
    height: 43.461,
    viewBox: "0 0 115.348 43.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.347,
    height: 43.461,
    fill: "#0a0a0a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-594.217 -815.227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21095.973-391.312h110.4s-9.293-40.353-54.508-41.163S21095.973-391.312,21095.973-391.312Z",
    transform: "translate(-20499.283 1250)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(594.217 815.227)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.032,43.461C7.331,39.134,18.58,6,57.671,6c39.523,0,50.366,33.008,51.649,37.461h6.012a2.962,2.962,0,0,0-.07-1.018A61.438,61.438,0,0,0,104,21.207C96.187,11.533,81.8,0,57.671,0S19.156,11.533,11.34,21.208A61.433,61.433,0,0,0,.085,42.443a2.961,2.961,0,0,0-.069,1.018Z",
    fill: "#0a0a0a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarBody);
export default __webpack_public_path__ + "static/media/avatarBody.b76bb3fb0afed5516f245d68a82c12fa.svg";
export { ForwardRef as ReactComponent };